import { render, staticRenderFns } from "./addRecommonPosition.vue?vue&type=template&id=37b83ff8&scoped=true"
import script from "./addRecommonPosition.vue?vue&type=script&lang=js"
export * from "./addRecommonPosition.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addRecommonPosition.vue?vue&type=style&index=1&id=37b83ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b83ff8",
  null
  
)

export default component.exports